import React from 'react';
import MaterialButtonGroup from '@material-ui/core/ButtonGroup';

const ButtonGroup = (props) => {
    return <MaterialButtonGroup color="primary" variant="contained" size="small" disableElevation={true} {...props}/>;
};

export default ButtonGroup;
